<template>
  <div class>
    <homeabout :isAbout="isAbout"></homeabout>
    <aboutDeve class="d-none d-md-block"></aboutDeve>
    <homepartner></homepartner>
    <div class="mm-container">
      <div class="container">
        <div class="row">
          <div class="col-12 map-box">
            <hometitle class="mm-box" title="地图位置" subtitle="Map"></hometitle>
            <div class="map-container">
              <baidumap
                :center="center"
                :zoom="zoom"
                @ready="handler"
                style="height:100%"
                :scroll-wheel-zoom="true"
                ak="bz5ncDsDGd4rFVG7RQIejSGv9nMKdNTb"
              ></baidumap>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HoemTitle from '../components/HomeTitle'
import homeabout from '../components/HomeAbout'
import aboutDeve from '../components/AboutDevelopment'
import homepartner from '../components/HomePartner'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'

export default {
  inject: ['reload'],
  data() {
    return {
      isAbout: true,
      basicinfoData: {},
      center: { lng: 113.457989, lat: 22.541526 },
      zoom: 18,
      message: {
        name: '',
        email: '',
        phone: '',
        body: ''
      },
      msgBtnColor: {
        color: ''
      },
      results: '',
      currentLanguage: '' // 当前语言
    }
  },
  methods: {
    handler({ BMap, map }) {
      var point = new BMap.Point(113.457989, 22.541526)
      map.centerAndZoom(point, 18)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      map.addOverlay(circle)
    },
    // 查询所有的基本信息
    findBasicinfo: async function() {
      const res = await this.$http.get('basicinfo')
      this.basicinfoData = res.data[0]
    }
  },
  created() {
    // this.findBasicinfo()
  },
  components: {
    hometitle: HoemTitle,
    homeabout: homeabout,
    aboutDeve: aboutDeve,
    homepartner: homepartner,
    baidumap: BaiduMap
  }
}
</script>
<style scoped>
.mm-container {
  padding: 30px 0;
}
.msg-model {
  display: block;
  width: 100%;
  padding: 10px 8px;
  background-color: #e8e8e8;
  font-size: 14px;
  color: #666;
  border: 0;
  margin-bottom: 20px;
  outline: none;
}
.bm-view {
  width: 100%;
  height: 300px;
}

*::-webkit-input-placeholder {
  color: #b8b8b8;
}
*::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b8b8b8;
}
*:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #b8b8b8;
}
*:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #b8b8b8;
}

.mm-box {
  margin-bottom: 20px !important;
}

textarea {
  height: 170px;
  resize: none;
}
.msg-btn {
  outline: none;
  padding: 10px 0;
  font-size: 14px;
  background-color: #048bd4;
  border: 0;
  color: #fff;
  text-align: center;
}
.msg-btn-text {
  font-size: 14px;
}
.map-container {
  height: 400px;
  background: url('../assets/image/map.jpg') no-repeat;
  background-size:100% 100%;
}

@media (max-width: 768px) {
  .map-box {
  margin-top: 30px;
}
.map-container {
  background: url('../assets/image/sm-map.jpg') no-repeat;
  background-size:100% 100%;
  width: 100%;
}
}
</style>